import React, { useState } from 'react'
import { limitLength } from '../../common/stringUtils';
import { BadgificationService } from "../../services/badgificationService";
import { NoteService } from '../../services/noteService';
import { sendEvent } from '../../modules/helpers/Analytics';
import { noteTextToReact, noteTextToPlainText } from '../../modules/helpers/noteTextFormatter';
import { NOTE_COLOR_NAMES } from '../../common/consts';

export default function Note({ note, selectedNotes, toggleSelectedNote }) {
    const title = note.title ? note.title : 'Markering';
    const text = note.text ?? null;
    const checkboxLabel = `${text ? noteTextToPlainText(text) : 'Markering'}, anteckning, ${NOTE_COLOR_NAMES[note.color] || note.color} markering`;

    const noteService = new NoteService();

    const badgificationService = new BadgificationService();

    const [isPinned, setIsPinned] = useState(note.isPinned);

    const handleOnclick = () => {
        badgificationService.addBadge(4, () => { }, () => { });
    }

    const pinNote = (noteId) => {
        noteService.pinNote(noteId,
            () => {
                setIsPinned(true);
                window.dispatchEvent(new Event("OnPinnedNoteChanged", { bubbles: false, cancelable: false }))
            },
            () => {
                console.error("Failed to toggle pinned status.");
            }
        );
    };

    const unPinNote = (noteId) => {
        noteService.unPinNote(noteId,
            () => {
                setIsPinned(false);
                window.dispatchEvent(new Event("OnPinnedNoteChanged", { bubbles: false, cancelable: false }))
            },
            () => {
                console.error("Failed to toggle pinned status.");
            }
        );
    };

    return (
        <li className={`notification note-color_borderLeft--${note.color}`}>
            <div className="bottom">
                <label className="notifications__select-item" onClick={(e) => e.stopPropagation()}>
                    <input
                        data-id={`${note.id}`}
                        type="checkbox"
                        onChange={() => toggleSelectedNote(note.id)}
                        className="notifications__select-checkbox"
                        aria-label={checkboxLabel}
                        checked={selectedNotes.indexOf(note.id) > -1} /><span>Välj denna</span>
                </label>

                <a href={`${note.pageUrl}#${note.markupId || ''}`} className="notification__header">
                    {text ? <span className="notification__header-text">{noteTextToReact(text)}</span> : <span className="notification__marking-label">Markering</span>}

                    {/* Enbart dekorativ – pekar mot dokumentet, hela headern (länken) hanterar klicket. */}
                    <span className="expandIcon" aria-hidden="true"></span>
                </a>
            </div>
        </li>
    )
}
 